export enum ShopifyProductFieldType {
  CategoryId = "category_id",
  Title = "title",
  Description = "description",
  Vendor = "vendor",
  ProductType = "product_type",
  Handle = "handle",
  SeoTitle = "seo_title",
  SeoDescription = "seo_description",
  Metafield = "metafield",
}
